<template>
  <div class="right-center">
    <div class="title-default">维权中心</div>
    <div class="right-tab">
      <div
        class="tab"
        v-for="(item, index) in rightTab"
        :key="index"
        :class="{ selected: item.isSelected }"
        @click="tabCheck(item)"
      >
        {{ item.name }}
      </div>
    </div>
    <div class="right-search">
      <div class="left-search">
        <div class="labels">
          <span>订单编号</span>
          <el-input
            class="default-input"
            type="number"
            v-model="orderNo"
            placeholder="请输入订单编号"
          ></el-input>
        </div>
        <div class="labels">
          <span>订单状态</span>
          <el-select
            v-model="complaintType"
            class="default-input"
            placeholder="请选择"
          >
            <el-option
              v-for="item in rightTab[0].isSelected
                ? complaintOptions
                : arbitrationOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </div>
        <el-button
          class="search-right"
          v-if="rightTab[0].isSelected"
          @click="getComplaintList()"
          >搜索</el-button
        >
        <el-button
          class="search-right"
          v-if="rightTab[1].isSelected"
          @click="getRefundArbitration()"
          >搜索</el-button
        >
      </div>
      <el-button
        class="complaint"
        @click="complaint = true"
        v-if="rightTab[0].isSelected"
        >我要投诉</el-button
      >
      <el-button
        class="complaint"
        @click="arbitration = true"
        v-if="rightTab[1].isSelected"
        >申请退款仲裁</el-button
      >
    </div>

    <div class="complaint-info" v-if="rightTab[0].isSelected">
      <div class="complaint-title">
        <div class="order-number">订单编号</div>
        <div class="complaint-content">投诉内容</div>
        <div class="complaint-state">投诉状态</div>
        <div class="complaint-time">提交时间</div>
        <div class="complaint-operation">操作</div>
      </div>
      <div class="null" v-show="complaintList.total == 0">
        <img src="../../assets/img/pic_none.png" alt />
        <div>没有搜索到相关数据…</div>
      </div>
      <div class="complaint-list" v-loading="loading">
        <div
          class="complaint-item"
          v-for="(item, index) in complaintList.rows"
          :key="index"
        >
          <div class="order-number">{{ item.orderNo }}</div>
          <div class="complaint-content">
            <div>{{ item.content }}</div>
          </div>
          <div class="complaint-state">{{ isStatus(item.status) }}</div>
          <div class="complaint-time">
            {{ item.complaintTime.split(" ")[0] }}
          </div>
          <div class="complaint-operation">
            <span class="complaint-detail" @click="openComplaintInfo(item)"
              >查看详情</span
            >
            <span
              class="revoke"
              @click="complaintCancel(item)"
              v-if="item.status == 'UNTREATED'"
              >撤销投诉</span
            >
          </div>
        </div>
      </div>
    </div>
    <div class="arbitration" v-if="rightTab[1].isSelected">
      <div class="arbitration-title">
        <div class="order-info">订单信息</div>
        <div class="arbitration-price">申请退款金额</div>
        <div class="actual-price">实际退款金额</div>
        <div class="arbitration-content">仲裁内容</div>
        <div class="arbitration-state">仲裁状态</div>
        <div class="arbitration-operation">操作</div>
      </div>
      <div class="arbitration-list">
        <div class="null" v-show="refundArbitrationList.total == 0">
          <img src="../../assets/img/pic_none.png" alt />
          <div>没有搜索到相关数据…</div>
        </div>
        <div
          class="arbitration-item"
          v-show="refundArbitrationList.total > 0"
          v-for="(item, index) in refundArbitrationList.rows"
          :key="index"
        >
          <div class="arbitration-item-title">
            <span>
              申请时间:{{ new Date(item.createTime).format("yyyy-MM-dd") }}
            </span>
            <span>退款单号:{{ item.refundNo }}</span>
            <span>订单号：{{ item.orderNo }}</span>
          </div>
          <div class="arbitration-item-content">
            <div class="order-info" v-if="item.orderItems.length == 1">
              <img :src="item.orderItems[0].imgUrl" alt />
              <div>{{ item.orderItems[0].name }}</div>
            </div>
            <div class="order-info" v-if="item.orderItems.length > 1">
              <img
                v-for="(it, ind) in item.orderItems"
                :key="ind"
                :src="it.imgUrl"
                v-if="ind <= 2"
                alt
              />
            </div>
            <div class="arbitration-price">
              ¥{{ item.applyArbitrationAmount }}
            </div>
            <div class="actual-price">
              {{
                item.status == "PROCESSED" ? "¥" + item.arbitrationAmount : "/"
              }}
            </div>
            <div class="arbitration-content">
              <div>{{ item.complaintDescription }}</div>
            </div>
            <div class="arbitration-state">
              {{ item.arbitrationStateName}}
            </div>
            <div class="arbitration-operation">
              <span class="complaint-detail" @click="openArbitration(item)"
                >查看详情</span
              >
              <span class="revoke" @click="arbitrationCancel(item)"
                >撤销投诉</span
              >
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 投诉列表分页 -->
    <el-pagination
      class="fenye"
      v-if="rightTab[0].isSelected && complaintList.total > 9"
      background
      layout="prev, pager, next"
      :total="complaintList.total"
      :page-size="9"
      @current-change="complaintPageSize"
    ></el-pagination>
    <!-- 退款仲裁分页 -->
    <el-pagination
      class="fenye"
      v-if="rightTab[1].isSelected && refundArbitrationList.total > 9"
      background
      layout="prev, pager, next"
      :total="refundArbitrationList.total"
      :page-size="9"
      @current-change="pageSize"
    ></el-pagination>
    <div id="orderlist">
      <!-- 投诉 -->
      <el-dialog
        title="投诉"
        @close="cancelPicker"
        :visible.sync="complaint"
        width="30%"
        class="complaint"
      >
        <div>
          <div class="two_label">
            <div class="type_name"><span class="xing">*</span>投诉订单号</div>
            <div class="type_content">
              <el-select
                v-model="complaintOrderNo"
                placeholder="请选择订单号"
                class="complaint-order-number"
                filterable
              >
                <el-option
                  v-for="item in complaintOrderNoList"
                  :key="item.orderNo"
                  :label="item.orderNo"
                  :value="item.orderNo"
                ></el-option>
              </el-select>
            </div>
          </div>
          <div class="two_label">
            <div class="type_name"><span class="xing">*</span>投诉内容</div>
            <div class="type_content">
              <el-input
                v-model="complaintContent"
                placeholder="请输入投诉内容"
                type="textarea"
              ></el-input>
            </div>
          </div>
          <div class="two_label">
            <div class="type_name"><span class="xing">*</span>投诉师傅</div>
            <div class="type_content">
              <a-switch
                checkedChildren="是"
                unCheckedChildren="关"
                v-model="defaultChecked"
              />
            </div>
          </div>
          <div class="complaint-img">
            <div class="complaint-title">相关图片</div>
            <a-upload
              :action="baseApl + '/common/common/upload_file'"
              listType="picture-card"
              :fileList="fileList"
              @change="handleChange"
            >
              <div v-if="fileList.length < 8">
                <a-icon type="plus" />
                <div class="ant-upload-text">上传</div>
              </div>
            </a-upload>
          </div>
        </div>

        <span slot="footer" class="dialog-footer">
          <el-button @click="complaint = false">取 消</el-button>
          <el-button type="primary" @click="isComplaint()">确 定</el-button>
        </span>
      </el-dialog>

      <!-- 投诉详情 -->
      <el-dialog
        title="投诉详情"
        :visible.sync="complaintInfo"
        width="30%"
        class="dialog-complaint-info"
      >
        <div>
          <div class="order-number">
            投诉订单号
            <span>{{ complaintData.orderNo }}</span>
          </div>
          <div class="dialog-complaint-content">
            <div>投诉内容</div>
            <div>{{ complaintData.content }}</div>
          </div>
          <div
            class="dialog-complaint-img"
            v-if="!complaintData.pictures ? false : true"
          >
            <div>相关图片</div>
            <div class="dialog-complaint-imgs">
              <!-- <img :src="item" alt v-for="(item, index) in complaintData.pictures" :key="index" /> -->
              <el-image
                v-for="(item, index) in complaintData.pictures"
                :key="index"
                :src="item"
                :preview-src-list="imgLis"
              >
              </el-image>
            </div>
          </div>
          <div class="dialog-complaint-content">
            <div>处理结果</div>
            <div>
              {{
                !complaintData.suggestion ? "处理中" : complaintData.suggestion
              }}
            </div>
          </div>
          <div style="height:19px;"></div>
        </div>
      </el-dialog>

      <!-- 申请退款仲裁 -->
      <el-dialog
        title="申请退款仲裁"
        :visible.sync="arbitration"
        @close="cancelPicker"
        width="30%"
        style="margin-top=8vh;"
        class="complaint dialog-arbitration"
      >
        <div>
          <div class="two_label">
            <div class="type_name"><span class="xing">*</span>退款订单号</div>
            <div class="type_content">
              <el-select
                v-model="reforderNo"
                filterable
                placeholder="请选择退款订单号"
                class="complaint-order-number"
                @change="openArbitrationOrder"
              >
                <el-option
                  v-for="item in arbitrationOrderNoList"
                  :key="item.orderNo"
                  :label="item.orderNo"
                  :value="item.orderNo"
                ></el-option>
              </el-select>
            </div>
          </div>
          <div v-if="arbitrationInfo">
            <div class="two_label">
              <div class="type_name">订单商品</div>
              <div class="type_content type_content_img">
                <img
                  :src="item.imgUrl"
                  alt
                  v-for="(item, index) in reforderData.orderItems"
                  :key="index"
                />
              </div>
            </div>
            <div class="two_label">
              <div class="type_name">
                订单总金额
                <span class="sqprice">¥{{ reforderData.totalAmount }}</span>
              </div>
            </div>

            <div class="two_label">
              <div class="type_name twelve">· 师傅补贴费</div>
              <div class="type_content sqarbitration">
                <el-input
                  v-model="subsidy"
                  @input="isSubsidy"
                  :placeholder="
                    '最多￥' + reforderData.workerCashIntransit + '元'
                  "
                  type="number"
                ></el-input>
                <div class="sqarbitration-tips">
                  师傅补贴费为支付给师傅的费用
                </div>
              </div>
            </div>
            <div class="two_label">
              <div class="type_name twelve">
                · 退款金额
                <span class="hong"
                  >¥{{
                    (reforderData.totalAmount * 1000 - subsidy * 1000) / 1000
                  }}</span
                >
              </div>
              <div class="type_content sqarbitration">
                <div class="sqarbitration-tips">
                  退款金额=订单总金额-师傅补贴费
                </div>
              </div>
            </div>

            <div class="two_label">
              <div class="type_name"><span class="xing">*</span>仲裁内容</div>
              <div class="type_content">
                <el-input
                  v-model="complaintValue"
                  placeholder="请输入投诉内容"
                  type="textarea"
                ></el-input>
              </div>
            </div>
            <div class="complaint-img">
              <div class="complaint-title">相关图片</div>
              <a-upload
                :action="baseApl + '/common/common/upload_file'"
                listType="picture-card"
                :fileList="fileList"
                @change="handleChange"
              >
                <div v-if="fileList.length < 8">
                  <a-icon type="plus" />
                  <div class="ant-upload-text">上传</div>
                </div>
              </a-upload>
            </div>
          </div>
        </div>

        <span slot="footer" class="dialog-footer">
          <el-button @click="arbitration = false">取 消</el-button>
          <el-button type="primary" @click="isArbitration()">提 交</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      rightTab: [
        { name: "投诉", isSelected: true },
        { name: "退款仲裁", isSelected: false }
      ],
      orderNo: "",
      fileList: [],
      complaint: false,
      complaintValue: "",
      complaintInfo: false,
      complaintData: {},
      arbitration: false,
      arbitrationInfo: false,
      loading: true,
      imgLis: [],
      complaintOptions: [
        {
          value: "DONE",
          label: "已处理"
        },
        {
          value: "UNTREATED",
          label: "未处理"
        },
        {
          value: "REVOKED",
          label: "已撤销"
        }
      ],
      arbitrationOptions: [
        {
          value: "ARBITRATION",
          label: "处理中"
        },
        {
          value: "PROCESSED",
          label: "已处理"
        },
        {
          value: "ARBITRATION_CANCEL",
          label: "已取消"
        }
      ],
      options: [],
      complaintType: "",
      page: 1,
      complaintPage: 1,
      refundArbitrationList: {
        rows: []
      },
      complaintList: {
        rows: []
      },
      total: 0,
      defaultChecked: false,
      complaintOrderNo: "",
      complaintOrderNoList: [],
      arbitrationOrderNoList: [],
      reforderNo: "",
      reforderData: {},
      complaintContent: "",
      subsidy: "",
      baseApl: process.env.VUE_APP_BASE_API
    };
  },
  mounted() {
    var _this = this;
    if (Cookies.get("token") != undefined) {
      this.getRefundArbitration();
      this.getComplaintList();
      this.getComplaintOrderOn();
    }
  },

  methods: {
    tabCheck(item) {
      this.complaintType = "";
      this.orderNo = "";
      for (let i of this.rightTab) {
        i.isSelected = false;
      }
      item.isSelected = true;
      if (item.name == "退款仲裁") {
        this.getRefundArbitrationOrder();
      }
    },
    // 获取可投诉订单
    getComplaintOrderOn() {
      this.$fetch(`/order/api/complaint/complaint_able_order`).then(res => {
        if (res.code == 0) {
          this.complaintOrderNoList = res.data;
        } else {
          this.$message(res.message);
        }
      });
    },
    // 获取申请仲裁订单号
    getRefundArbitrationOrder() {
      let _this = this;
      this.$fetch(`/order/api/refund`,{
        pageNum: _this.page,
        pageSize: 9,
        refundStatusEnum: "ARBITRATION_ALL",
      }).then(res => {
        if (res.code == 0) {
          console.log(res);
          this.arbitrationOrderNoList = res.data.rows;
        } else {
          this.$message(res.message);
        }
      });
    },
    // 打开退款订单详情
    openArbitrationOrder(item) {
      this.fileList = [];
      let _this = this;
      this.arbitrationInfo = true;
      this.arbitrationOrderNoList.map(i => {
        if (i.orderNo == item) {
          _this.reforderData = i;
        }
      });
    },
    // 关闭弹窗初始化数据
    cancelPicker() {
      this.fileList = [];
      this.complaintOrderNo = "";
      this.complaintContent = "";
      this.defaultChecked = false;
      this.arbitrationInfo = false;
      this.reforderNo = "";
      this.subsidy = "";
      this.complaintValue = "";
    },
    // 打开投诉详情
    openComplaintInfo(item) {
      this.complaintInfo = true;
      item.pictures.map(i => {
        this.imgLis.push(i);
      });
      this.complaintData = item;
    },
    // 根据id投诉
    isComplaint() {
      this.$message.closeAll();
      if (this.complaintContent == "") {
        this.$message.error("请先填写投诉内容");
        return;
      }
      let imgs = this.fileList.map(i => i.response.data.url).join("|");
      this.$post(
        `/order/api/complaint/add_complaint/${this.complaintOrderNo}?content=${
          this.complaintContent
        }&picUrls=${imgs}&complaintObject=${this.defaultChecked ? 0 : 1}`,
        {
          content: this.complaintContent,
          picUrls: imgs,
          complaintObject: this.defaultChecked ? 0 : 1
        }
      ).then(res => {
        if (res.code == 0) {
          this.complaintContent = "";
          this.fileList = [];
          this.getComplaintList();
          this.complaint = false;
          this.$message({
            message: "投诉成功",
            type: "success"
          });
        } else {
          this.$message(res.message);
        }
      });
    },
    // 判断师傅补贴费用
    isSubsidy(val) {
      console.log(val);
      if (val > Number(this.reforderData.workerCashIntransit)) {
        console.log(this.reforderData.workerCashIntransit);
        this.subsidy = this.reforderData.workerCashIntransit;
      }
    },
    // 根据id仲裁
    isArbitration() {
      this.$message.closeAll();
      if (this.complaintValue == "") {
        this.$message.error("请先填写仲裁内容");
        return;
      }
      if (this.subsidy == "") {
        this.$message.error("请填写师傅补贴费");
        return;
      }
      let imgs = this.fileList.map(i => i.response.data.url);
      this.$post(`/order/api/refund/${this.reforderNo}/arbitration`, {
        content: this.complaintValue,
        allowance: this.subsidy,
        imgs: JSON.stringify(imgs)
      }).then(res => {
        if (res.code == 0) {
          this.getRefundArbitration();
          this.arbitration = false;
          this.$message({
            message: "仲裁提交成功",
            type: "success"
          });
        } else {
          this.$message(res.message);
        }
      });
    },
    // 判断投诉状态
    isStatus(item) {
      if (item == "DONE") {
        return "已处理";
      }
      if (item == "UNTREATED") {
        return "未处理";
      }
      if (item == "REVOKED") {
        return "已撤销";
      }
    },
    // 获取退款仲裁列表
    getRefundArbitration() {
      this.loading = true;
      let _this = this;
      this.$fetch(`/order/api/refund`, {
        pageNum: _this.page,
        pageSize: 9,
        refundStatusEnum: this.complaintType == ""?"ARBITRATION_ALL":this.complaintType,
        orderNo: this.orderNo
      }).then(res => {
        if (res.code == 0) {
          _this.refundArbitrationList = res.data;
          this.loading = false;
        } else {
          this.$message(res.message);
        }
      });
    },
    // 查看投诉列表
    getComplaintList() {
      this.loading = true;
      this.$fetch(`/order/api/complaint/complaint_list`, {
        pageNum: this.complaintPage,
        pageSize: 9,
        complaintType: this.complaintType,
        orderNo: this.orderNo
      }).then(res => {
        if (res.code == 0) {
          this.complaintList = res.data;
          this.loading = false;
        } else {
          this.$message(res.message);
        }
      });
    },
    // 退款仲裁分页取值
    pageSize(val) {
      this.page = val;
      this.getRefundArbitration();
    },
    // 投诉列表分页取值
    complaintPageSize(val) {
      this.complaintPage = val;
      this.getComplaintList();
    },
    // 投诉拍照
    handleChange({ fileList }) {
      this.fileList = fileList;
    },
    // 取消投诉
    complaintCancel(item) {
      let _this = this;
      this.$confirm("确认取消投诉吗？", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.$fetch(`/order/api/complaint/${item.id}/revoke`).then(res => {
            if (res.code == 0) {
              item.status = "REVOKED";
              this.$message({
                type: "success",
                message: "撤销成功!"
              });
            } else {
              this.$message(res.message);
            }
          });
        })
        .catch(() => {});
    },
    // 取消仲裁
    arbitrationCancel(item) {
      this.$confirm("确认取消仲裁吗？", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.$post(`/order/api/refund/${item.id}/cancel`).then(res => {
            if (res.code == 0) {
              _this.refundArbitrationList.rows.remove(item);
              this.$message({
                type: "success",
                message: "撤销成功!"
              });
            } else {
              this.$message(res.message);
            }
          });
        })
        .catch(() => {});
    },
    // 进入仲裁详情页
    openArbitration(item) {
      this.$router.push({
        path: "/user/right/detail",
        query: { refundId: item.id }
      });
    }
  }
};
</script>
<style lang="scss">
.labels {
  .el-input .el-input__suffix {
    width: 29px;
    right: 21px;
  }
}
#orderlist {
  .two_label {
    color: #2f3133;
    .type_content_img {
      display: flex;
      img {
        width: 50px;
        height: 50px;
        margin-right: 5px;
      }
      img:last-child {
        margin-right: 0;
      }
    }
    .sqarbitration {
      input {
        width: 100%;
      }
      .sqarbitration-tips {
        font-size: 12px;
        color: #909399;
        line-height: 1;
        height: 12px;
        margin-top: 8px;
      }
    }
    .type_name {
      .sqprice {
        margin-left: 16px;
      }
    }
    .twelve {
      font-size: 12px;
      margin-bottom: 8px;
      .hong {
        color: #f75658;
        font-size: 14px;
        margin-left: 16px;
      }
    }
  }
  .dialog-arbitration {
    .el-dialog {
      margin-top: 8vh !important;
    }
  }
}
</style>
<style lang="scss" scoped>
.title-default {
  background: #ffffff;
  border-bottom: 1px solid #e8eef5;
}
.right-tab {
  display: flex;
  background: #ffffff;
  height: 46px;
  line-height: 1;
  font-size: 14px;
  padding: 14px 20px;
  cursor: pointer;
  .tab {
    margin-right: 36px;
  }
  .selected {
    border-bottom: 1px solid #3455d3;
    color: #3455d3;
    font-weight: bold;
    padding-bottom: 19px;
  }
}
.right-center {
  margin-bottom: 100px;
  &/deep/.el-loading-spinner .circular {
    margin-top: 100px;
  }
  .right-search {
    background: #ffffff;
    padding: 10px 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .complaint {
      // width: 64px;
      height: 24px;
      border-radius: 2px;
      border: 1px solid rgba(144, 147, 153, 1);
      padding: 0 8px;
      font-size: 12px;
      color: #5e6066;
    }
    .complaint:hover,
    .complaint:focus {
      color: #5e6066;
      background: transparent;
    }
  }
  .left-search {
    display: flex;
    .labels {
      display: flex;
      width: 266px;
      font-size: 12px;
      align-items: center;
      margin-right: 20px;
      .default-input {
        width: 210px;
        margin-left: 8px;
      }
    }
    .search-right {
      width: 70px;
      height: 30px;
      background: rgba(52, 85, 211, 1);
      border-radius: 2px;
      padding: 0;
      font-size: 14px;
      color: #ffffff;
      border-color: rgba(52, 85, 211, 1);
    }
  }
  .complaint-info {
    margin-top: 15px;
    .complaint-title {
      background: #f9fafa;
      height: 30px;
      display: flex;
      padding-left: 20px;
      color: #5e6066;
      font-size: 12px;
      & > div {
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
    .complaint-list {
      .complaint-item {
        background: #ffffff;
        display: flex;
        padding-left: 20px;
        margin-top: 10px;
        & > div {
          display: flex;
          justify-content: center;
          align-items: center;
          height: 70px;
          font-size: 12px;
          color: #5e6066;
        }
      }
      .complaint-content {
        padding: 19px 16px;
        overflow: hidden;
        div {
          height: 36px;
          overflow: hidden;
        }
      }
    }
    .order-number {
      width: 140px;
    }
    .complaint-content {
      width: 383px;
    }
    .complaint-state,
    .complaint-time {
      width: 104px;
    }
    .complaint-operation {
      width: 146px;
    }
  }
  .dialog-complaint-info {
    .order-number {
      color: #5e6066;
      font-size: 14px;
      display: flex;
      margin-top: 10px;
      span {
        color: #2f3133;
        margin-left: 15px;
      }
    }
    .dialog-complaint-content,
    .dialog-complaint-img {
      margin-top: 30px;
      &/deep/.el-image-viewer__canvas {
        img {
          width: auto !important;
          height: auto !important;
        }
      }
      & > div:nth-child(1) {
        color: #5e6066;
        font-size: 14px;
        height: 14px;
        line-height: 1;
        margin-bottom: 12px;
      }
      & > div:nth-child(2)/deep/ {
        color: #2f3133;
        font-size: 12px;
        line-height: 20px;
        img {
          width: 50px;
          height: 50px;
          border-radius: 2px;
          margin-right: 5px;
        }
        img:last-child {
          margin-right: 0;
        }
      }
    }
  }
  .complaint-operation,
  .arbitration-operation {
    flex-direction: column;
    cursor: pointer;
    .complaint-detail {
      color: #3455d3;
    }
    .revoke {
      margin-top: 7px;
    }
  }
  .arbitration {
    margin-top: 15px;
    .arbitration-title {
      padding-left: 20px;
      color: #5e6066;
      font-size: 12px;
      display: flex;
      background: #f9fafa;
      height: 30px;
      & > div {
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
    .arbitration-list {
      .arbitration-item {
        margin-top: 10px;
        .arbitration-item-title {
          background: #f9fafa;
          height: 34px;
          display: flex;
          align-items: center;
          color: #909399;
          font-size: 12px;
          border-bottom: 1px solid #dfe4eb;
          padding-left: 20px;
          span {
            margin-right: 16px;
          }
        }
        .arbitration-item-content {
          height: 102px;
          padding: 16px 0 16px 20px;
          display: flex;
          background: #ffffff;
          & > div {
            font-size: 12px;
            color: #5e6066;
            display: flex;
            justify-content: center;
            align-items: center;
          }
          .order-info {
            justify-content: flex-start;
            img {
              width: 70px;
              height: 70px;
              margin-right: 10px;
            }
            div {
              width: 166px;
              height: 32px;
            }
          }
          .actual-price {
            color: #f75658;
          }
          .arbitration-price,
          .actual-price {
            font-size: 13px;
            font-weight: bold;
          }
          .arbitration-content {
            padding: 10px 13px;
            div {
              // height: 49px;
              overflow: hidden;
              line-height: 16px;
              max-height: 49px;
            }
          }
        }
      }
    }
    .order-info {
      width: 247px;
    }
    .arbitration-price {
      width: 103px;
    }
    .actual-price {
      width: 110px;
      padding-left: 10px;
    }
    .arbitration-content {
      width: 219px;
    }
    .arbitration-state {
      width: 104px;
    }
    .arbitration-operation {
      width: 94px;
    }
  }
}
#orderlist {
  .complaint-order-number {
    width: 429px;
    &/deep/ input {
      width: 100% !important;
    }
  }
}
</style>
